import GalleryLightbox, {
  GalleryLightboxProps
} from '@portalterreno/react-ui/GalleryLightbox';
import Visible from '@portalterreno/react-ui/Visible';
import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import React from 'react';

import PropertyTitle, { PropertyTitleProps } from './PropertyTitle';
import ShareButtonMobile from './ShareButton/ShareButtonMobile';
import Wrapper from './Wrapper';

export type PropertyPageHeaderProps = Pick<
  PropertyTitleProps,
  | 'urlOperation'
  | 'urlPropertyType'
  | 'communeId'
  | 'communeName'
  | 'communeSlug'
  | 'cityId'
  | 'cityName'
  | 'citySlug'
  | 'regionName'
> & {
  campaignChipText?: string;
  communeSlug: string;
  citySlug: string;
  communeName: string;
  id: number;
  logo?: string;
  operation: string;
  photos: GalleryLightboxProps['items'];
  price: number;
  principalCurrency: string;
  propertyType: string;
  regionName: string;
  title: string;
  videoId?: GalleryLightboxProps['videoId'];
  videoProvider?: GalleryLightboxProps['videoProvider'];
};

const PropertyPageHeader: React.FC<PropertyPageHeaderProps> = ({
  id,
  campaignChipText,
  communeId,
  communeName,
  communeSlug,
  cityId,
  cityName,
  citySlug,
  logo,
  operation,
  photos,
  price,
  principalCurrency,
  propertyType,
  regionName,
  title,
  urlOperation,
  urlPropertyType,
  videoId,
  videoProvider
}) => {
  React.useEffect(() => {
    if (window && window.dataLayer) {
      window.dataLayer.push({
        event: 'view_property',
        marketplace: {
          operation,
          category: propertyType,
          currency: principalCurrency,
          value: price,
          item_id: id,
          region: regionName,
          province: cityName,
          city: communeName
        }
      });
    }
  }, [
    cityName,
    communeName,
    id,
    operation,
    price,
    principalCurrency,
    propertyType,
    regionName
  ]);
  return (
    <Wrapper>
      <Row>
        <Col lg={12}>
          <PropertyTitle
            communeId={communeId}
            communeName={communeName}
            communeSlug={communeSlug}
            cityId={cityId}
            cityName={cityName}
            citySlug={citySlug}
            campaignChipText={campaignChipText}
            regionName={regionName}
            title={title}
            logo={logo}
            urlOperation={urlOperation}
            urlPropertyType={urlPropertyType}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Visible mobile>
            <ShareButtonMobile />
          </Visible>
          <GalleryLightbox
            items={photos}
            lightboxSubtitle={`${regionName}, ${cityName}`}
            lightboxTitle={title}
            videoId={videoId}
            videoProvider={videoProvider}
          />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default React.memo(PropertyPageHeader);
